export const DEPRECATED_STITCH_PAYMENT_STEP_TYPE = 'stitch_payment'

export const isDeprecatedStitchPaymentStepType = (stepType: string): boolean => {
  return stepType === DEPRECATED_STITCH_PAYMENT_STEP_TYPE
}

export const filterDeprecatedCollectDataSteps = <T extends { type: string }>(steps: T[]): T[] => {
  return steps.filter((step) => {
    return !isDeprecatedStitchPaymentStepType(step.type)
  })
}
